// Przeciążenie – rozszerzenie o page_type: NOT_FOUND
// @ts-nocheck

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IHrefLang {
  language: string;
  url_shortcut: string;
}

export interface ISeoPageInfoTranslation {
  language: string;
  translation: string | null;
}

export interface IResponse {
  page_type: 'PRODUCTS' | 'PRODUCT' | 'CMS_PAGE' | 'HOME_PAGE' | 'NOT_FOUND';
  parameters: string;
  href_lang: IHrefLang[];

  meta_title?: ISeoPageInfoTranslation[];
  meta_description?: ISeoPageInfoTranslation[];
  meta_keywords?: ISeoPageInfoTranslation[];
  h1?: ISeoPageInfoTranslation[];
  open_graph_title?: ISeoPageInfoTranslation[];
  open_graph_description?: ISeoPageInfoTranslation[];
  open_graph_image?: string;
}

export type IRequest = {
  urlKey: string;
};

const getLayoutUrlResolver = (params?: IRequest): Promise<IResponse> =>
  axios.get('/layout/url_resolver', { params });

export const useGetLayoutUrlResolver = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['url-resolver', params],
    () => getLayoutUrlResolver(params),
    options
  );
